import { parseToDateString } from '../date-picker/utilities.js';
import { rescheduleSession } from './ajax.js';
import bookingStore from './store.js';
import { calculateDuration } from './utilities.js';

export function handleSelectTimeSlot() {
	const container = document.getElementById('time-slot');
	if (!container) return;
	container.addEventListener('click', (e) => {
		const clickedItem = e.target.closest('.time-slot-item');
		if (!clickedItem) return;
		if (clickedItem.dataset.disabled === 'true') return;

		// Remove active from all other time-slot-item
		container.querySelectorAll('.time-slot-item.active').forEach((item) => {
			item.classList.remove('active');
		});

		// Add active to clicked item
		clickedItem.classList.add('active');
		bookingStore.setSelectedTime(clickedItem.dataset.time, clickedItem.dataset.endTime);
	});
}


export function handleBookNow() {
	const bookNowBtn = document.querySelectorAll('[data-action="book-session"]');

	if (!bookNowBtn) return;
	bookNowBtn.forEach((btn) => {
		btn.addEventListener('click', async () => {

			btn.disabled = true;
			// Validate date and time selection
			let selectedDate = bookingStore.getSelectedDate();
			if (!selectedDate) {
				wpcore.alert('error', wpcore.direct_t({ en: 'Please select a date first', fr: 'Veuillez d\'abord s\u00e9lectionner une date' }));
				btn.disabled = false;
				return;
			}

			selectedDate = parseToDateString(selectedDate);

			const selectedTime = bookingStore.getSelectedTime();
			if (!selectedTime) {
				wpcore.alert('error', wpcore.direct_t({ en: 'Please select a time slot first', fr: 'Veuillez d\'abord s\u00e9lectionner un cr\u00e9neau horaire' }));
				btn.disabled = false;
				return;
			}

			// Calculate duration from time range (e.g., "09:30-10:00")
			const { startTime, endTime } = selectedTime;
			const duration = calculateDuration(startTime, endTime);

			// Always redirect to payment for session booking
			const params = new URLSearchParams({
				date: selectedDate,
				time: startTime,
				duration: duration
			});
			window.location.href = `/students/payment-session?${params.toString()}`;
		});
	});
}


export function handleReschedule() {
	const rescheduleBtn = document.querySelectorAll('[data-action="reschedule-session"]');
	if (!rescheduleBtn) return;
	rescheduleBtn.forEach((btn) => {
		btn.addEventListener('click', async () => {
			btn.disabled = true;
			// Validate date and time selection
			let selectedDate = bookingStore.getSelectedDate();
			if (!selectedDate) {
				alert(wpcore.direct_t({ en: 'Please select a date first', fr: 'Veuillez d\'abord s\u00e9lectionner une date' }));
				btn.disabled = false;
				return;
			}

			selectedDate = parseToDateString(selectedDate);

			const selectedTime = bookingStore.getSelectedTime();
			if (!selectedTime) {
				alert(wpcore.direct_t({ en: 'Please select a time slot first', fr: 'Veuillez d\'abord s\u00e9lectionner un cr\u00e9neau horaire' }));
				btn.disabled = false;
				return;
			}

			// Calculate duration from time range (e.g., "09:30-10:00")
			const { startTime, endTime } = selectedTime;
			const duration = calculateDuration(startTime, endTime);

			// Get session ID from hidden input
			const sessionIdInput = document.getElementById('reschedule-session-id');
			if (!sessionIdInput || !sessionIdInput.value) {
				wpcore.alert('error', wpcore.direct_t({ en: 'Session ID not found', fr: 'Identifiant de session introuvable' }));
				btn.disabled = false;
				return;
			}

			const sessionId = sessionIdInput.value;

			const response = await rescheduleSession(sessionId, selectedDate, startTime, duration);
			if (!response) {
				btn.disabled = false;
				return;
			}

			btn.disabled = false;

			// Show reschedule success popup if available, otherwise redirect
			const prevDateEl = document.getElementById('reschedule-prev-date');
			const prevTimeEl = document.getElementById('reschedule-prev-time');
			const newDateEl = document.getElementById('reschedule-new-date');
			const newTimeEl = document.getElementById('reschedule-new-time');

			if (prevDateEl && newDateEl && typeof wpcore.showPopup === 'function') {
				prevDateEl.textContent = response.prev_date || '';
				prevTimeEl.textContent = response.prev_time || '';
				newDateEl.textContent = response.new_date || '';
				newTimeEl.textContent = response.new_time || '';

				// Populate person info: student sees coach, coach sees student
				const isCoach = window.location.pathname.startsWith('/coach/');
				const coach = response.coach || {};
				const student = response.student || {};
				const person = isCoach ? student : coach;

				const avatarEl = document.getElementById('reschedule-student-avatar');
				const nameEl = document.getElementById('reschedule-student-name');
				const planEl = document.getElementById('reschedule-student-plan');
				const emailEl = document.getElementById('reschedule-student-email');
				if (avatarEl) avatarEl.src = person.avatar || '';
				if (nameEl) nameEl.textContent = person.name || '';
				if (planEl) planEl.textContent = (isCoach ? student.plan : coach.specialty) || '';
				if (emailEl) emailEl.textContent = student.email || '';

				// Set back button href based on context
				const backBtn = document.getElementById('reschedule-back-btn');
				if (backBtn) {
					backBtn.href = isCoach ? '/coach/visio-management/' : '/students/my-sessions/';
					backBtn.textContent = isCoach
						? wpcore.direct_t({ en: 'Back to Visio Management', fr: 'Retour à la gestion Visio' })
						: wpcore.direct_t({ en: 'Back to My Sessions', fr: 'Retour à mes sessions' });
				}

				wpcore.showPopup('reschedule-success');
			} else {
				const isCoach = window.location.pathname.startsWith('/coach/');
				window.location.href = isCoach ? '/coach/visio-management/' : '/students/my-sessions/';
			}
		});
	});
}
